module.exports = __webpack_public_path__ + "img/elo.4a55683e.png";